<template>
  <div class="printer-calibration-information">
    <img
      src="/static/images/printer-model.png" 
      width="418"
      height="344"
      alt="Na imagem: foto de uma impressora, com um circulo para orientar o local identificador do modelo"
    >
    <p>
      Na etiqueta indicada na imagem acima, você visualiza
      <br>o modelo da sua impressora.
    </p>
  </div>
</template>

<script>
export default {
  name: 'PrinterCalibrationInformation'
}
</script>

<style lang="scss">
.printer-calibration-information {
  p {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 26px;
    color: #617173;
  }
}
</style>
